// Muller Homes Brand Colors
export const B = {
  black:   "#000000",
  dark:    "#111111",
  navy:    "#1A1A1A",
  card:    "#181818",
  slate:   "#252525",
  mid:     "#333333",
  muted:   "#6F6F6F",
  light:   "#E0E0E0",
  white:   "#FFFFFF",
  gold:    "#9A732F",
  goldlt:  "#F8DA6B",
  green:   "#4CAF7D",
  red:     "#C0392B",
  border:  "#2A2A2A",
};

export const FONT = '"Avenir Next", Avenir, -apple-system, "Segoe UI", sans-serif';

export const LOGO = "/icons/logo.png";
export const LOGO_FALLBACK = "https://mullerhomesllc.com/wp-content/uploads/2025/02/FinalLogo_mh.png";

// Project IDs
export const PROJECT_IDS = {
  CHASSEY: 1,
  MCVEY: 2,
  LANDERS: 3,
};

// Google Drive Media folder IDs
export const DRIVE_MEDIA_FOLDERS = {
  1: "1Ww2LuFXi8PxV4pVMpoIQekhzA0Jz2FYN",
  2: "1oRoS-NXvBdyQkru3hVLe7i7HHLy8X7o5",
  3: "1PH2p8eivHFJLv3Y-DcAMy3TOiov5nt2H",
};

// Google Sheets IDs
export const SHEET_IDS = {
  1: "10XOOYS3yaXsmwf4wk5BHOXO1Y6LJ5c5qKMPzfAZShJ0",
  2: "1TeirSGjgSZalSDpyxxAHFImBZmmzCD7xeU99Hb4rAck",
  3: "12aZNIwtf4z8jveRGFyWRfHlqwvIe4lCGrPfj0RUHCcs",
};

// Gmail Decisions Label IDs
export const GMAIL_DECISION_LABELS = {
  1: "Label_6890804445761292913",
  2: "Label_7329500082513087893",
  3: "Label_4344594187148882788",
};

// Google Calendar IDs
export const CALENDAR_IDS = {
  1: "c_302d5aa72ee0a3272acdab11bbba4252e49adbba40580ec72cd053ac1e325159@group.calendar.google.com",
  2: "c_b625171041af345e8f81429093c1018d46db18f89c246691922dfedec0f4337b@group.calendar.google.com",
  3: "c_040b600f9e9f5e9338e2c9695ed3a6d28bf67056318bcf60beb825bcc3a5f463@group.calendar.google.com",
};

// Trades list
export const TRADES = [
  "Excavation","Foundation","Concrete","Framing","Roofing","Siding",
  "Masonry","Plumbing","Electrical","HVAC","Insulation","Drywall",
  "Tile","Painter","Trim","Flooring","Cabinetry","Window/Door Install",
  "Fireplace","Low Voltage","Inspection","Surveyor","Muller","Other"
];

// Weather conditions
export const WEATHER_OPTIONS = [
  "Sunny","Partly Cloudy","Overcast","Rain","Heavy Rain",
  "Thunderstorm","Windy","Cold","Snow","Hot","Great"
];

// WMO weather codes
export const WMO = {
  0:"Clear",1:"Mainly Clear",2:"Partly Cloudy",3:"Overcast",
  45:"Fog",61:"Light Rain",63:"Rain",65:"Heavy Rain",
  71:"Snow",80:"Showers",95:"Thunderstorm"
};

export const WX_ICON = {
  0:"☀️",1:"🌤",2:"⛅️",3:"☁️",45:"🌫",
  61:"🌦",63:"🌧",65:"🌧",71:"❄️",80:"🌦",95:"⛈"
};

// Formatters
export const fmt$ = (n) =>
  "$" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (d) => {
  try {
    return new Date(d + "T12:00:00").toLocaleDateString("en-US", {
      month: "short", day: "numeric", year: "numeric"
    });
  } catch { return d; }
};

export const fmtShort = (d) => {
  try {
    return new Date(d + "T12:00:00").toLocaleDateString("en-US", {
      month: "short", day: "numeric"
    });
  } catch { return d; }
};

export const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; };
